module.exports = __webpack_public_path__ + "media/images/pages/img_largeStore_03-ce4407895c90ae1590f0441025daf346.jpg";